module.exports = __webpack_public_path__ + "img/3cda5c2a950f04dedb9023acbaf1109f.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo2.png
// module id = 910
// module chunks = 5